import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'
import ImageOrVideo from "../Widgets/ImageOrVideo"
import CentredContentContainer from "../Widgets/CentredContentContainer"
import Heading from "../Widgets/Heading"
import Link from "../Widgets/Link"
import theme from "../../styles/theme"
import Caption from "../Widgets/Caption"
import ShopTheLookLink from "../ShopThLook/ShopTheLookLink"

const DEFAULT_TITLE_TAG = 'h3';

class ArticleListItem extends PureComponent {

    render() {
        const {classes, item} = this.props;
        const {image, video, caption, title, title_tag, description, button_link, shop_the_look_title, shopItems} = item;
        const hasShopItems = shopItems && shopItems.length > 0;
        const shopTheLookImage = hasShopItems && ((image && image.desktop) || (video && video.image.desktop))

        return <section>
            <div className={classes.imageContainer}>
                {(image || video) &&
                <ImageOrVideo images={image} video={video} sizes="(min-width: 820px) 820px, 100vw" link={button_link}>
                    {hasShopItems && <ShopTheLookLink title={shop_the_look_title} shopItems={shopItems} image={{desktop: shopTheLookImage}}/>}
                </ImageOrVideo>
                }
                {caption && <Caption className={classes.caption} caption={caption}></Caption>}
            </div>
            <CentredContentContainer className={classes.itemContent} verticalPadding>
                {title && <Heading tag={title_tag || DEFAULT_TITLE_TAG} className={classes.heading}>{title}</Heading>}
                {description && <div dangerouslySetInnerHTML={{__html: description}}></div>}
                {button_link && button_link.url && <div><Link link={button_link}></Link></div>}
            </CentredContentContainer>
        </section>
    }
}

export default injectSheet(
    {
        imageContainer: {
            maxWidth: theme.content.widthMedium,
            marginBottom: theme.spacing.normal,
            marginLeft: "auto",
            marginRight: "auto"
        },
        caption: {
            marginBottom: 0,
            marginLeft: "1.5rem",
            [theme.breakpoint("laptop")]: {
                marginLeft: "0",
            }
        },
        heading: {
            fontStyle: 'normal',
        },
    }
)(ArticleListItem)





// WEBPACK FOOTER //
// ./src/components/Article/ArticleListItem.js